<style>
  #v-order {
    min-height: 100%;
    background-color: #f5f5f5;
    font-size: 13px;
    padding-bottom: 15px;
  }
  #v-order .eso-breadcrumb{
    padding-left: 0;
    margin: 10px 0;
  }
  .extends-rule-tip{
    font-size: 13px;
    background-color: #FCF9F0;
    color:#E19817;
    padding: 8px 5px;
  }
  .area-container{
    padding-left: 5px;
  }
  #v-order p.title{
    color: #999;
  }
  .area-container .title.select{
    margin-bottom: 0;
  }
  #v-order p.title>span:first-child{
    color:#555;
    font-weight: bold;
  }
  .area-container .input-prefix-search{
    color:#DADADA;
    position: absolute;
    z-index: 1000;
    font-size: 18px;
    line-height: 37px;
    margin-left: 10px;
  }
  .area-container .city-select{
    width: 100%;
  }
  .area-container .city-select  .el-input__inner{
    padding-left: 32px;
  }
  #v-order .no-data {
    font-size: 13px;
    margin-bottom: 0;
    color: #999;
  }
  .core-words-container .eso-tags {
    margin-top: -15px;
  }
  .line-split {
    position: absolute;
    height: calc(100% - 100px);
    width: 1px;
    float: left;
    display: inherit;
    border-left: 1px solid #ddd;
    margin-top: 10px;
  }
  .line-split.l1{
    left: 34.6%;
  }
  .line-split.l2{
    left: 65.3%;
  }
  .business-container{
    padding-right: 5px;
  }
  .business-container .btn-refresh{
    color:#20A0FF;
    cursor: pointer;
    float: right;
  }
  .business-container .btn-refresh span{
    font-size: 13px;
  }
  .business-container .chk-business .el-checkbox{
    color: #555;
    margin-left: 0px;
    margin-bottom: 8px;
  }
  .business-container .chk-business .el-checkbox .el-checkbox__label{
    width: 64px;
    display: inline-block;
  }
  .business-container .eso-tags{
    margin-top: -15px;
  }

  #v-order .btn-bar{
    text-align: center;
    margin: 20px auto;
  }
  .preview-container{
    /*padding-bottom: 20px;*/
  }
  #v-order .preview-container .title{
    color: #555;
    margin-top: 0;
    font-weight: bold;
  }
  .single-word-title{
    color:#1376EB;
    font-weight: bold;
    font-size: 16px;
  }
  .single-word .extend-list{
    margin: 0;
    padding: 0;
  }
  .single-word .extend-list li{
    color:#555;
    padding: 8px;
    width: 20%;
    font-size: 12px;
    float: left;
    list-style-type: none;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    border:1px dashed #ddd;
  }
  .single-word .extend-list li.split-extend-word{
    width: 100%;
    border: 0;
  }
  .see-more{
    margin-top: 15px;
    margin-bottom: 0;
    text-align: center;
    color: #1376EB;
    font-weight: bold;
    font-size: 14px;
  }
  .see-more span{
    cursor: pointer;
  }
  .see-more i{
    position: absolute;
    margin-left: 5px;
  }
  #v-order .btn-bar.fixed{
    position: fixed;
    top:0;
    left: 0;
    background-color: #f5f5f5;
    width: 100%;
    z-index: 1000;
    margin: 0;
    padding: 20px 0;
    box-shadow: 0 1px 5px 3px rgba(0,0,0,.1);
  }
  .eso-go-top {
    cursor: pointer;
    width: 50px;
    height: 50px;
    position: fixed;
    bottom: 154px;
    right: 332px;
    background-color: white;
    border: 1px solid #ddd;
    text-align: center;
    padding-top: 9px;
  }
  @media screen and (max-width : 1366px) {
    .eso-go-top{
      right: 61px;
    }
  }
  .eso-go-top i{
    color: #888;
    font-size: 26px;
  }
  .eso-confim-show-dialog {
    width: 410px;
  }
  .eso-confim-show-dialog .select_shows{
    width: 77%;
  }
  .select_shows_items {
    width:100%;
    color: #8492a6;
    font-size: 13px;
    font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
  }
  li.select_shows_items_container.selected .select_shows_items{
    color:white;
  }
  .eso-confim-word-dialog {
    width: 700px;
  }
  .eso-confim-word-dialog .el-dialog__body{
    padding-top: 10px;
  }
  #v-order  .eso-confim-word-dialog p.title {
    font-size: 13px;
    color:#555;
    margin-bottom: 0;
  }
  .eso-confim-word-dialog .action-bar{
    margin-top: 30px;
  }
  .eso-confim-word-dialog .action-bar p.tips{
    text-align: center;
    font-size: 13px;
  }
  .eso-confim-word-dialog .action-bar p.tips.danger {
    color:#FF4949;
  }
  .eso-confim-word-dialog .action-bar .btn-container {
    text-align: center;
    margin-bottom: 0;
  }
  .eso-confim-word-dialog .action-bar .btn-container .el-button{
    padding: 10px 30px;
  }
  .eso-confim-final-dialog{
    width: 495px;
  }
  .eso-confim-final-dialog p{
    text-align: center;
  }
  .eso-confim-final-dialog .el-icon-warning{
    font-size: 76px;
    color: #F7BA2A;
  }
  .eso-result-dialog p{
    text-align: center;
  }
  .eso-result-dialog .el-icon-circle-check{
    font-size: 76px;
    color:#13CE66;
  }
  .eso-result-dialog .el-icon-circle-cross{
    font-size: 76px;
    color:#FF4949;
  }
  .eso-result-dialog {
    width: 400px;
  }
</style>

<template>
  <div id="v-order" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="el-row container">
      <div class="el-col el-col-24 ">
          <eso-breadcrumb v-bind:breadcrumbs="breadcrumbs"></eso-breadcrumb>
          <div class="eso-panel clearfix">
            <div class="extends-rule-tip">
              扩展规则: 系统自动8个前缀延伸 ( 地域 ) + 核心词 ( 主词 ) + 8后缀延伸 ( 商机 ) , 然后根据每个核心词扩展80个精准采购词
            </div>
            <div class="el-col el-col-8 area-container">
              <p class="title"><span>地区</span> ( 请输入地区名称，用于扩展前缀 ) <span class="el-icon-plus" style="float:right;cursor:pointer;" v-show="isSuperAdmin" @click="dialogAddPrefixVisible = true"></span></p>
              <i class="el-icon-search input-prefix-search"></i>
              <el-select v-model="selectedCity" filterable :disabled="rule.citys.length === 8" placeholder="请输入地区名称，例如：珠海" class="city-select" v-on:change="cityChange">
              <el-option
                v-for="city in citys"
                :label="city"
                :value="city">
              </el-option>
            </el-select>
            <p class="title select"><span>已选择地区</span>  ( 需选择8个区域 , 已选{{rule.citys.length}}个 ) </p>
            <p class="no-data" v-show="rule.citys.length === 0">暂无地区</p>
              <eso-tags v-model="rule.citys" @click="cityOnSelect"></eso-tags>
            </div>
            <div class="line-split l1"></div>
            <div class="el-col el-col-8 core-words-container">
              <p class="title"><span>核心关键词</span> ( 本区域是您选择好的关键词 )</p>
              <p class="no-data" v-show="rule.words.length === 0">暂无关键词</p>
              <eso-tags v-model="rule.words" label="keyword" @click="wordOnSelect"></eso-tags>
            </div>
            <div class="line-split l2"></div>
            <div class="el-col el-col-8 business-container" >
              <p class="title">
                <span>商机</span>
                <span>( 依据网民搜索习惯，用于匹配后缀 )</span>
                <span @click="dialogAddSuffixVisible = true" v-show="isSuperAdmin" style="float:right;cursor:pointer;">
                  <i class="el-icon-plus"></i>
                </span>
                <span class="btn-refresh" @click="changeSuffixIndex">
                  <i class="iconfont icon-shuaxin"></i>
                  <span>换一批</span>
                </span>
              </p>
              <el-checkbox-group class="chk-business" v-model="rule.suffix" @change="bussinessOnChange">
                <el-checkbox v-for="item in business.data" :label="item" :disabled="rule.suffix.length >= 8 " >{{item}}</el-checkbox>
              </el-checkbox-group>
              <p class="title select" style="margin-top:5px"><span>已选择的商机</span>  ( 需选择8个商机,已选{{rule.suffix.length}}个 )</p>
              <p class="no-data" v-show="rule.suffix.length === 0">暂无选择商机</p>
              <eso-tags v-model="rule.suffix" @click="suffixOnSelect"></eso-tags>
            </div>
          </div>
      </div>
    </div>
    <div class="el-row container btn-bar">
      <div class="el-col el-col-24">
        <!--<el-button type="default" size="large">返回新增词</el-button>
        <el-button type="default" size="large">生成扩展词预览</el-button>
        <el-button type="default" size="large">确认导入关键词</el-button>-->
        <el-button type="default" @click="goAddWord"><i class="iconfont icon-fanhui" style="margin-right:15px;font-size:14px;"></i>返回新增词</el-button>
        <el-tooltip v-show="rule.citys.length !== 8 || rule.suffix.length !==8 || rule.words.length === 0" placement="top" content="地域与商机必须各选8个，且核心词不能为空">
          <el-button type="default" style="margin-left:10px;" >生成扩展词预览</el-button>
        </el-tooltip>
        <el-button type="default" style="margin-left:10px;" @click="previewInit" v-show="rule.citys.length === 8 && rule.suffix.length ===8 && rule.words.length > 0">生成扩展词预览</el-button>
        <el-button type="default" @click="submit">确认导入关键词</el-button>
        <el-button type="default" v-show="isSuperAdmin" @click="exportRestult">导出到execl</el-button>
      </div>
    </div>
    <transition enter-active-class="animated slideInDown">
      <div class="el-row container btn-bar fixed" v-show="overflowScrolled">
        <div class="el-col el-col-24">
          <el-button type="default" @click="goAddWord"><i class="iconfont icon-fanhui" style="margin-right:15px;font-size:14px;"></i>返回新增词</el-button>
          <el-button type="default" @click="previewInit">生成扩展词预览</el-button>
          <el-button type="default" @click="submit">确认导入关键词</el-button>
          <el-button type="default" v-show="isSuperAdmin" @click="exportRestult">导出到execl</el-button>
        </div>
      </div>
    </transition>
    <div class="el-row container preview-container" v-show="preview.length != 0">
      <div class="el-col el-col-24">
        <div class="eso-panel clearfix">
          <p class="title">扩展词预览</p>
          <div class="single-word" v-for="word in preview">
            <p class="single-word-title">{{word.keyword}}</p>
            <ul class="extend-list clearfix">
              <template v-for="(extend_word, index) in word.extends">
                <li :title="extend_word">
                  <span>{{index<9 ? '0'+(index+1) : index+1}}. </span>
                  <span>{{extend_word.split(word.keyword)[0]}}</span>
                  <span style="color:#1376EB;margin-left:-2px;">{{word.keyword}}</span>
                  <span style="margin-left:-2px;">{{extend_word.split(word.keyword)[1]}}</span>
                </li>
                <li v-show="(index + 1) % 25 === 0" class="split-extend-word"></li>
              </template>
            </ul>
          </div>
          <div class="see-more" v-show="preview.length < rule.words.length">
            <span @click="previewCreate(preview.length)">查看更多扩展词</span>
            <i class="iconfont icon-xiangxiashouqi"></i>
          </div>
        </div>
      </div>
    </div>
    <transition enter-active-class="animated fadeIn">
        <div class="eso-go-top" v-show="overflowScrolled" @click="goTop">
          <i class="iconfont icon-iconziti57"></i>
        </div>
    </transition>


    <el-dialog v-model="dialog.show.visibility" title="请选择展台" size="tiny" custom-class="eso-confim-show-dialog clearfix">
      <p v-show="dialog.show.state === -1">载入失败, 请关闭对话框重试或联络管理员</p>
      <el-select v-show="dialog.show.state === 0" disabled  placeholder="正在载入展台列表" class="select_shows"></el-select>
      <el-select v-show="dialog.show.state === 1" v-model="rule.showid" placeholder="请选择需要导入关键词的展台" class="select_shows">
        <el-option style="height:54px;" class="select_shows_items_container"
          v-for="show in dialog.show.list"
          :label="show.name"
          :value="show.id">
          <span>{{ show.name }}</span>
          <div class="select_shows_items">
            {{ show.uri }}
          </div>
        </el-option>
      </el-select>
      <el-button v-show="dialog.show.state === 1" type="default" style="float:right" @click="openConfirm">确 认</el-button>
    </el-dialog>

    <el-dialog v-model="dialog.eso.visibility" title="关键词导入确认" size="tiny" custom-class="eso-confim-word-dialog clearfix">
      <p class="title">所选择的核心词 ( {{rule.words.length}}个 )</p>
      <eso-tags v-model="rule.words" label="keyword" @click="wordOnSelect"></eso-tags>
      <p class="title">所选择的地域词 ( {{rule.citys.length}}个 )</p>
      <eso-tags v-model="rule.citys" @click="cityOnSelect"></eso-tags>
      <p class="title">所选择扩展词 ( {{rule.suffix.length}}个 )</p>
      <eso-tags v-model="rule.suffix" @click="suffixOnSelect"></eso-tags>
      <p style="color:#FF4949;font-weight:bold;text-align:center;margin-bottom:0;" v-show="dialog.eso.state === -1">
         加载错误，请关闭对话框重试或联络管理员
      </p>
      <div class="action-bar" v-show="dialog.eso.state === 1">
          <p class="tips danger" v-show="rule.suffix.length < 8 || rule.citys.length < 8">地域词与扩展词必须各为8个, 请添加地域词或扩展词</p>
          <p class="tips danger" v-show="rule.suffix.length > 8 || rule.citys.length > 8">地域词与扩展词分别不能超出8个</p>
          <p class="tips danger" v-show="rule.words.length + dialog.eso.optimized > dialog.eso.max && dialog.eso.max !== 0">
            您当前服务购买了{{dialog.eso.max}}个关键词，<span v-show=" dialog.eso.optimized !== 0">正在优化{{dialog.eso.optimized}}个，</span>当前所选词{{rule.words.length}}个，
            多选了{{rule.words.length + dialog.eso.optimized - dialog.eso.max}}个。
          </p>
          <p class="tips danger" v-show="rule.words.length + dialog.eso.optimized < dialog.eso.max && dialog.eso.max !== 0">
            您当前服务购买了{{dialog.eso.max}}个关键词，<span v-show=" dialog.eso.optimized !== 0">正在优化{{dialog.eso.optimized}}个，</span>当前所选词{{rule.words.length}}个，
            还有{{dialog.eso.max - dialog.eso.optimized - rule.words.length }}个可以添加。
          </p>
          <p class="tips danger" v-show="dialog.eso.max === 0">您当前暂无购买任何优化套餐，提交后服务人员会第一时间联系您开通服务</p>
          <p class="btn-container">
            <el-button type="default" v-show="rule.words.length + dialog.eso.optimized < dialog.eso.max" @click="goAddWord">去添加新词</el-button>
            <el-button type="default" v-show="dialog.eso.max !== 0" @click="openFinalSubmit" :disabled="rule.words.length + dialog.eso.optimized > dialog.eso.max || (rule.suffix.length != 8 || rule.citys.length != 8) ">确认提交</el-button>
            <el-button type="default" v-show="dialog.eso.max === 0" :disabled="rule.suffix.length != 8 || rule.citys.length != 8" @click="finalSubmit(true)">提交到缓存库</el-button>
          </p>
      </div>
    </el-dialog>

    <el-dialog v-model="dialog.final.visibility" size="tiny" custom-class="eso-confim-final-dialog clearfix">
      <p><i class="el-icon-warning"></i></p>
      <p style="font-size:22px;">请再次确认关键词，开始优化后无法修改</p>
      <p style="color:#F7BA2A">确认优化后，在服务开启后则不可更改数据</p>
      <p>
        <el-button @click="finalSubmit" >确认提交</el-button>
        <el-tooltip placement="top" content="暂不提交，保存至后台暂存库">
          <el-button style="margin-left:15px;" type="primary" @click="finalSubmit(true)">保存</el-button>
        </el-tooltip>
      </p>
    </el-dialog>

    <el-dialog v-model="dialog.result.visibility" size="tiny" custom-class="eso-result-dialog clearfix">
      <div v-show="dialog.result.state === 1">
        <p><i class="el-icon-circle-check"></i></p>
        <p style="font-size:22px;color: #13CE66;" v-show="dialog.result.type === 0">提交成功 !</p>
        <p style="font-size:22px;color: #13CE66;" v-show="dialog.result.type === 1">保存成功 !</p>
        <p>您可以跳转到后台进行查看 <span style="color:#1D8CE0;cursor:pointer;" @click="goYsoAdmin">去查看</span> 3 秒后回到首页</p>
      </div>
      <div v-show="dialog.result.state === -1">
        <p><i class="el-icon-circle-cross"></i></p>
        <p style="font-size:22px;color: #FF4949;">提交失败 !</p>
        <p>请重试或联络管理员</p>
      </div>
    </el-dialog>

    <el-dialog title="提示" v-model="mustLogindialogVisible" size="tiny">
      <span>如果要查看缓存库，必须先进行登录。如果已登录请尝试刷新当前页面~</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mustLogindialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="mustLogindialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="自定义前缀" :visible.sync="dialogAddPrefixVisible" size="tiny">
      <el-input v-model="form.name" auto-complete="off" placeholder="请输入自定义前缀"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAddPrefixVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureAddPrefix">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="自定义后缀" :visible.sync="dialogAddSuffixVisible" size="tiny">
      <el-input v-model="form.name" auto-complete="off" placeholder="请输入自定义后缀"></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAddSuffixVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureAddSuffix">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import esoBreadcrumb from '../components/core/breadcrumb'
import esoTags from '../components/core/tag'
import { mapState } from 'vuex'
// import _ from 'lodash'

import Citys from '../assets/data/citys.json'
import Suffix from '../assets/data/suffix.json'

export default {
  name: 'order',
  computed: mapState({ user: state => {
    return state.user
  }}),
  data () {
    return {
      isSuperAdmin: false,
      form: {
        name: ''
      },
      dialogAddPrefixVisible: false,
      dialogAddSuffixVisible: false,
      mustLogindialogVisible: false,
      fullscreenLoading: false,
      dialog: {
        show: {
          visibility: false,
          state: 0,
          list: []
        },
        eso: {
          visibility: false,
          state: 0,
          max: 0,
          optimized: 0
        },
        final: {
          visibility: false
        },
        result: {
          visibility: false,
          type: 0,
          state: 0
        }
      },
      overflowScrolled: false,
      breadcrumbs: [{
        text: '优化指数查询'
      }],
      citys: Citys,
      business: {
        index: 0,
        data: []
      },
      rule: {
        showid: '',
        citys: [],
        words: [],
        suffix: []
      },
      preview: [],
      selectedCity: ''
    }
  },
  components: {
    esoBreadcrumb,
    esoTags
  },
  mounted () {
    this.isSuperAdmin = (this.user && this.user.email === 'ysb-admin@yi-z.cn')
    let sid = this.$route.query.sid
    window.addEventListener('scroll', this.handleScroll)

    if (sid) {
      this.getCacheOrder(sid)
    } else {
      this.getDataFromStorage()
    }
    this.getSuffixByIndex()
    // this.previewInit()
  },
  methods: {
    getDataFromStorage () {
      let strOrders = window.localStorage.getItem('orders')
      let strCitys = window.localStorage.getItem('citys')
      let strSuffix = window.localStorage.getItem('suffix')
      try {
        if (strOrders && strOrders !== 'null') {
          this.rule.words = JSON.parse(strOrders)
        }
        if (strCitys && strCitys !== 'null') {
          this.rule.citys = JSON.parse(strCitys)
        }
        if (strSuffix && strSuffix !== 'null') {
          this.rule.suffix = JSON.parse(strSuffix)
        }
      } catch (e) {
        console.log(e)
      }
    },
    getCacheOrder (sid) {
      this.fullscreenLoading = true
      setTimeout(() => {
        if (this.user.uid) {
          this.$http.get(`${process.env.API_URI}api/eso/cache`, {
            params: {
              uid: this.user.uid,
              showid: 300046
            }
          }).then(res => {
            this.fullscreenLoading = false
            if (res.body.main && res.body.main.length !== 0) {
              window.localStorage.setItem('citys', JSON.stringify(res.body.prefix))
              window.localStorage.setItem('orders', JSON.stringify(res.body.main))
              window.localStorage.setItem('suffix', JSON.stringify(res.body.suffix))
              this.getDataFromStorage()
            } else {
              console.log('读取缓存库失败....')
              console.log(res)
            }
          }, e => {
            this.fullscreenLoading = false
            console.log('读取缓存库失败....')
            console.log(e)
          })
        } else {
          this.fullscreenLoading = false
          this.mustLogindialogVisible = true
          this.getDataFromStorage()
        }
      }, 500)
    },
    goTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    goYsoAdmin () {
      window.open(`${process.env.ADMIN_URI}YiSouBao/YiSouBaoIndex`)
    },
    handleScroll () {
      this.overflowScrolled = window.scrollY > 557
    },
    changeSuffixIndex () {
      var maxIndex = Math.ceil(Suffix.length / 8) - 1
      this.business.index = this.business.index + 1 > maxIndex ? 0 : this.business.index + 1
      this.getSuffixByIndex()
    },
    getSuffixByIndex () {
      let startIndex = this.business.index * 8
      this.business.data = Suffix.slice(startIndex, startIndex + 8)
    },
    wordOnSelect (index) {
      this.preview = []
      this.rule.words.splice(index, 1)
      window.localStorage.setItem('orders', JSON.stringify(this.rule.words))
    },
    suffixOnSelect (index) {
      this.rule.suffix.splice(index, 1)
    },
    cityOnSelect (index) {
      this.rule.citys.splice(index, 1)
      this.saveCity()
    },
    saveCity () {
      this.preview = []
      window.localStorage.setItem('citys', JSON.stringify(this.rule.citys))
    },
    bussinessOnChange () {
      // this.rule.suffix = this.selectedBusiness
      this.preview = []
      window.localStorage.setItem('suffix', JSON.stringify(this.rule.suffix))
    },
    sureAddSuffix () {
      let val = this.form.name
      if (val === '') {
        return false
      }
      if (this.rule.suffix.indexOf(val) === -1) {
        this.rule.suffix.push(val)
      }

      this.dialogAddSuffixVisible = false
      this.form.name = ''

      this.bussinessOnChange()
    },
    goAddWord () {
      if (this.rule.words.length === 0) {
        this.$router.push({
          name: 'index'
        })
      } else {
        this.$router.push({
          name: 'search',
          params: {
            word: this.rule.words[0].keyword
          }
        })
      }
    },
    cityChange (val) {
      if (val === '') {
        return false
      }
      if (this.rule.citys.indexOf(val) === -1) {
        this.rule.citys.push(val)
      }
      this.selectedCity = ''
      this.saveCity()
    },
    sureAddPrefix () {
      this.cityChange(this.form.name)
      this.dialogAddPrefixVisible = false
      this.form.name = ''
    },
    previewInit () {
      this.preview = []
      this.previewCreate(0)
    },
    previewCreate (index) {
      let item = {
        keyword: this.rule.words[index].keyword,
        extends: []
      }
      for (let city of this.rule.citys) {
        let w = city + item.keyword
        for (let s of this.rule.suffix) {
          item.extends.push(w + s)
        }
      }
      this.preview.push(item)
    },
    openConfirm () {
      if (this.rule.showid !== '' && this.rule.showid !== 0) {
        this.dialog.show.visibility = false
        setTimeout(() => {
          this.dialog.eso.visibility = true
          this.dialog.eso.state = 0
          this.$http.get(`${process.env.API_URI}api/eso/info`, {
            params: {
              uid: this.user.uid,
              showid: this.rule.showid
            }
          }).then(res => {
            this.dialog.eso.state = 1
            this.dialog.eso.max = res.body.max
            this.dialog.eso.optimized = res.body.optimized
          }, e => {
            this.dialog.eso.state = -1
            console.log(e)
          })
        }, 400)
      }
    },
    exchangeWords () {
      let main = []
      for (let word of this.rule.words) {
        main.push({
          KeyWord: word.keyword,
          Index: word.sindex,
          IsMain: true
        })
      }
      let extend = []
      for (let word of main) {
        for (let city of this.rule.citys) {
          let w = city + word.k
          for (let s of this.rule.suffix) {
            extend.push({
              KeyWord: w + s,
              Index: 0,
              IsMain: false
            })
          }
        }
      }
      return main.concat(extend)
    },
    getMainWord () {
      let result = []
      for (let item of this.rule.words) {
        result.push(item.keyword)
      }
      return result
    },
    finish () {
      setTimeout(() => {
        window.localStorage.removeItem('orders')
        window.localStorage.removeItem('citys')
        window.localStorage.removeItem('suffix')
        setTimeout(() => {
          window.location.href = '/'
        }, 1000)
      }, 3000)
    },
    finalSubmit (isCache) {
      if (isCache) {
        this.dialog.eso.visibility = false
        this.dialog.result.type = 1
      } else {
        this.dialog.result.type = 0
      }
      this.dialog.final.visibility = false
      setTimeout(() => {
        this.fullscreenLoading = true
        let data = this.exchangeWords()

        let handles = isCache ? this.$http.post(`${process.env.API_URI}api/eso/submit/cache`, {
          uid: this.user.uid,
          showid: this.rule.showid,
          prefix: this.rule.citys,
          main: this.getMainWord(),
          suffix: this.rule.suffix
        }) : this.$http.post(`${process.env.API_URI}api/eso/submit`, {
          uid: this.user.uid,
          showid: this.rule.showid,
          words: data
        })

        handles.then(res => {
          this.fullscreenLoading = false
          this.dialog.result.visibility = true
          if (res.body.message === 'success') {
            this.dialog.result.state = 1
            this.finish()
          } else {
            this.dialog.result.state = -1
            console.log(res)
          }
        }, e => {
          this.dialog.result.visibility = true
          this.dialog.result.state = -1
          this.fullscreenLoading = false
          console.log(e)
        })
      }, 400)
    },
    openFinalSubmit () {
      this.dialog.eso.visibility = false
      setTimeout(() => {
        this.dialog.final.visibility = true
      }, 400)
    },
    submit () {
      if (this.user.uid) {
        this.dialog.show.visibility = true
        this.dialog.show.state = 0
        this.rule.showid = ''
        this.$http.get(`${process.env.API_URI}api/user/shows`, {
          params: {
            uid: this.user.uid
          }
        }).then(res => {
          this.dialog.show.list = res.body
          this.dialog.show.state = 1
          if (this.dialog.show.list.length === 1) {
            this.rule.showid = this.dialog.show.list[0].id
            this.openConfirm()
          }
        }, e => {
          this.dialog.show.state = -1
          console.log(e)
        })
      } else {
        window.location.href = `${process.env.ADMIN_URI}account/login?returnUrl=${window.location.href}`
      }
    },
    exportRestult () {
      let prefix = []
      let suffix = []
      let words = []
      for (let city of this.rule.citys) {
        prefix.push(city)
      }
      for (let s of this.rule.suffix) {
        suffix.push(s)
      }
      for (let w of this.rule.words) {
        words.push(w.keyword)
      }
      var host = `${process.env.API_URI}`
      window.location.href = host + 'api/export?prefixs=' + prefix.join(',') + '&words=' + words.join(',') + '&suffixs=' + suffix.join(',')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Order.vue?cd13ab2c